import { SUPER_ADMIN_DASHBOARD_ISSUES_LIST } from '../../../constants';

const initialState = {
  data: [],
  loading: true,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case SUPER_ADMIN_DASHBOARD_ISSUES_LIST.LOAD:
      return {
        ...state,
        loading: true,
      };
    case SUPER_ADMIN_DASHBOARD_ISSUES_LIST.SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case SUPER_ADMIN_DASHBOARD_ISSUES_LIST.FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
